"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusNodeTexture = void 0;
const nexus_node_1 = require("./nexus-node");
class NexusNodeTexture {
    constructor(id, start = 0, end = 0, status = nexus_node_1.NexusNodeDataStatus.ABSENT) {
        this.id = id;
        this.start = start;
        this.end = end;
        this.status = status;
        this.references = 0; // number of active nodes referencing the texture
        this.webGLId = null;
    }
    get size() {
        return this.end - this.start;
    }
}
exports.NexusNodeTexture = NexusNodeTexture;
NexusNodeTexture.EMPTY_TEXTURE = new NexusNodeTexture(-1, 0, 0, nexus_node_1.NexusNodeDataStatus.PRESENT);
